import { Controller } from "@hotwired/stimulus";
import { useIntersection } from "stimulus-use";

export default class extends Controller {
  appear(): void {
    if (this.element instanceof HTMLElement) {
      this.element.click();
    }
  }

  connect(): void {
    const options = {
      threshold: 1,
    };

    useIntersection(this, options);
  }
}
